import { useState } from "react";
import FileUploadComponent from "../fileupload/fileUploadComponent";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import FeaturesTable from "./featuresTable";
import {
  addFeatureIdToGeoJSONProperties,
  getAttributesFromGeoJSON,
  getGeoJSONData,
} from "../../lib/featureUtils";
import { cloneDeep } from "lodash";
import { trans } from "../../lib/utils";

function SelectFeaturesFromUploadFile(props) {
  const [fileRequiresExtraInfo, setFileRequiresExtraInfo] = useState(false);
  const [fileProjection, setFileProjection] = useState(null);
  const [fileGeoJSON, setFileGeoJSON] = useState(null);

  return (
    <>
      <FileUploadComponent
        onDropFeatures={(geoJson, ext, fileName) => {
          if (!geoJson.hasPrjFile) {
            if (ext === "zip") {
              setFileRequiresExtraInfo(true);
            }
          }

          let newGeoJSON = cloneDeep(geoJson);

          let data = getGeoJSONData(geoJson);

          setFileGeoJSON({
            geoJSON: { ...newGeoJSON },
            attributes: [...getAttributesFromGeoJSON(geoJson)],
            data: [...data],
          });
        }}
      ></FileUploadComponent>
      {fileRequiresExtraInfo ? (
        <>
          <div className="mt-2">
            <small>{trans("* No prj file detected!")}</small>
          </div>
          <div className="mb-3">
            <label className="color-get-blue strong ">
              {trans("Select projection system")}
            </label>
            <div className="mt-2 input-group">
              <select
                className="form-select form-select-sm "
                value={fileProjection}
                onChange={(e) => {
                  setFileProjection(e.target.value);
                }}
              >
                <option value="">{trans("Select projection system")}</option>
                {window["appConfig"]()["projectionSystems"].map((opt) => {
                  return <option value={opt.code}>{opt.title}</option>;
                })}
              </select>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {(!fileRequiresExtraInfo || (fileRequiresExtraInfo && fileProjection)) &&
      fileGeoJSON?.geoJSON ? (
        <div className="mt-2 ">
          <PerfectScrollbar style={{ height: "15rem" }}>
            <div className="me-3">
              <FeaturesTable
                attributes={[...fileGeoJSON.attributes]}
                data={[...fileGeoJSON.data]}
                controls={["zoom"]}
                selected={props.selected ? props.selected : []}
                onSelect={(feature) => {
                  if (props.onSelect) {
                    props.onSelect(feature);
                  }
                }}
              ></FeaturesTable>
            </div>
          </PerfectScrollbar>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default SelectFeaturesFromUploadFile;
